<template>
    <el-select
        v-model="selectedService"
        @input="$emit('input', selectedService)"
        @change="$emit('change', selectedService)"
    >
        <el-option
            v-for="option in expiredServiceOptions"
            :key="option.value"
            :label="option.label"
            :value="option.value"
        />
    </el-select>
</template>

<script>

export default {
  name: 'StatusSelect',
  props: {
    value: {
      type: [Boolean, String],
      default: true,
    },
  },
  data() {
    return {
      selectedService: this.value,
      expiredServiceOptions: [
        { label: 'Active', value: true },
        { label: 'Inactive', value: false }
      ],
    };
  },
  watch: {
    value(newValue) {
      this.selectedService = newValue;
    },
  },
};
</script>
